import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { StatsStrip } from "@/components/StatsStrip";
import { ServicesSection } from "@/components/ServicesSection";
import { DeliveryPromise } from "@/components/DeliveryPromise";
import { CommerceSpotlight } from "@/components/CommerceSpotlight";
import { SystemsShowcase } from "@/components/SystemsShowcase";
import { CaseStudies } from "@/components/CaseStudies";
import { ProcessSection } from "@/components/ProcessSection";
import { AboutSection } from "@/components/AboutSection";
import { Testimonials } from "@/components/Testimonials";
import { FAQSection } from "@/components/FAQSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <main className="bg-background text-foreground">
      <Navbar />
      <HeroSection />
      <StatsStrip />
      <ServicesSection />
      <DeliveryPromise />
      <CommerceSpotlight />
      <SystemsShowcase />
      <CaseStudies />
      <ProcessSection />
      <AboutSection />
      <Testimonials />
      <FAQSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
